var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGroup776(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 529,
    height: 529,
    viewBox: "0 0 529 529",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .cls-2, .cls-4 {\r\n        fill: url(#linear-gradient);\r\n      }\r\n\r\n      .cls-3, .cls-5 {\r\n        fill: #053261;\r\n      }\r\n\r\n      .cls-4, .cls-5 {\r\n        stroke: rgba(0,0,0,0);\r\n        stroke-miterlimit: 10;\r\n      }\r\n\r\n      .cls-6 {\r\n        filter: url(#Ellipse_16);\r\n      }\r\n\r\n      .cls-7 {\r\n        filter: url(#Ellipse_18);\r\n      }\r\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_18",
    x: 0,
    y: 0,
    width: 529,
    height: 529,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 3,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3,
    result: "blur"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "blur"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "Ellipse_16"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5,
    result: "blur-2"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.239,
    result: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "out",
    in: "SourceGraphic",
    in2: "blur-2"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in: "color"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.33,
    y1: 0.03,
    x2: 0.716,
    y2: 0.961,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fabb33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f88604"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_776",
    "data-name": "Group 776",
    transform: "translate(10020.098 -3839.06)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-7",
    transform: "matrix(1, 0, 0, 1, -10020.1, 3839.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_18-2",
    "data-name": "Ellipse 18",
    className: "cls-1",
    cx: 255.5,
    cy: 255.5,
    r: 255.5,
    transform: "translate(9 6)"
  })), /*#__PURE__*/React.createElement("g", {
    "data-type": "innerShadowGroup"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-2",
    "data-name": "Ellipse 16",
    className: "cls-1",
    cx: 232,
    cy: 232,
    r: 232,
    transform: "translate(-9987.098 3869.06)"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-6",
    transform: "matrix(1, 0, 0, 1, -10020.1, 3839.06)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16-3",
    "data-name": "Ellipse 16",
    className: "cls-1",
    cx: 232,
    cy: 232,
    r: 232,
    transform: "translate(33 30)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_627",
    "data-name": "Group 627",
    transform: "translate(-9927.736 3926.812)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_548",
    "data-name": "Group 548",
    transform: "translate(0 137.358)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_173",
    "data-name": "Path 173",
    className: "cls-2",
    d: "M-16534.469-8411.546v133s9.809-2.614,16.105-8.9a48.685,48.685,0,0,0,9.133-12.388l-.105-86.2h29.262a13.748,13.748,0,0,1,6.48,3.517c2.832,2.829,4.84,7.809,4.84,7.809a32.985,32.985,0,0,0,2.9-13.252,33.027,33.027,0,0,0-2.9-13.126,16.094,16.094,0,0,0-3.617-5.433,18.41,18.41,0,0,0-12.32-5.024C-16489.75-8411.6-16534.469-8411.546-16534.469-8411.546Z",
    transform: "translate(16534.469 8411.572)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_174",
    "data-name": "Path 174",
    className: "cls-2",
    d: "M-16532.352-8274.72s11.957-3.432,17.791-10.565a121.759,121.759,0,0,0,10.266-14.988h36.416s10.633-4.843,10.973-16.334-10.973-16.329-10.973-16.329-24.559,0-26.852,0-5.539-3.823-5.309-12.228c.211-8.4,3.432-11.215,5.309-11.231,1.908-.014,18.867,0,18.867,0a49.646,49.646,0,0,0,13.855-24.677c3.3-15.338-5.984-28.576-5.984-28.576s27.732,3.76,30.658,28.09-14.207,34.491-14.207,34.491,11.068,4.27,16.932,11.524c5.879,7.26,7.676,11.006,7.619,18.936s-1.006,18.246-10.986,28.718c-10.01,10.473-29.9,13.17-29.9,13.17Z",
    transform: "translate(16537.229 8412.368)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_179",
    "data-name": "Path 179",
    className: "cls-3",
    d: "M-446.188-81.655v-82.777h14.757l.062,82.777Zm-25.05-75.956a46.7,46.7,0,0,0,4.529-7.539,20.748,20.748,0,0,0,1.7-6.661h58.632v14.2Zm61.757,75.956,33.855-90.156h10.789l33.855,90.156h-15.935l-23.314-67.152-23.252,67.152Zm15.935-17.113v-14.2h47.434v14.2Zm119.794,17.113-22.632-38.257-1.8-3.038-29.576-48.86H-311.7l21.02,35.4,2.17,3.72,30.817,51.03Zm-54.751,0,31.933-53.511,21.454-36.645h16.059l-29.825,49.852-23.562,40.3Zm82.591,0V-96.784h15.129v15.129Z",
    transform: "translate(574.785 356.617)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_367",
    "data-name": "Rectangle 367",
    className: "cls-4",
    width: 37.781,
    height: 89.206,
    transform: "translate(110.493 89.205)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_368",
    "data-name": "Rectangle 368",
    className: "cls-5",
    width: 37.781,
    height: 76.087,
    transform: "translate(277.885 102.324)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_369",
    "data-name": "Rectangle 369",
    className: "cls-5",
    width: 37.256,
    height: 124.363,
    transform: "translate(236.43 54.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_370",
    "data-name": "Rectangle 370",
    className: "cls-5",
    width: 37.256,
    height: 124.363,
    transform: "translate(194.451 54.049)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_371",
    "data-name": "Rectangle 371",
    className: "cls-5",
    width: 37.256,
    height: 178.411,
    transform: "translate(152.472)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup776);
export default __webpack_public_path__ + "static/media/Group 776.15da4797b031e23eb6b46a8a715ad9ba.svg";
export { ForwardRef as ReactComponent };